import FaqAccordion from "./FaqAccordion.jsx";
import { Localization } from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import QuestionAccordion from "./QuestionAccordion.jsx";
import React from "react";

export default class FaqCard extends React.PureComponent {
    constructor(props){
        super(props);
        this.renderFaq = this.renderFaq.bind(this);
    }

    renderFaq() {
        const {
            localization,
            faq
        } = this.props;

        const groupBy = (key, array) =>
            array.reduce( (objectsByKeyValue, obj) => {
                const value = obj[key];
                objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
                return objectsByKeyValue;
            }, {}
            );

        const subjects = groupBy("subject", faq);
        const map = new Map(Object.entries(subjects));
        const nodes = [];

        for (const [subject, questions] of map) {
            const childrenNodes = [];

            questions.forEach(function(question) {
                childrenNodes.push(
                    <QuestionAccordion key={`q-${childrenNodes.length}`} label={question.questionMarkdown}>
                        {question.answerMarkdown}
                    </QuestionAccordion>
                );
            });
            nodes.push(
                <FaqAccordion key={`sub-${nodes.length}`} label={subject} localization={localization} count={childrenNodes.length}>
                    {childrenNodes}
                </FaqAccordion>
            );
        }
        return nodes;
    }

    render(){
        const {
            height
        } = this.props;
        
        
        
        return (
            <div className="card-default" style={{height:height}}>
                <div className="faq-wrapper" style={{height:(height-16-1)}}>
                    {this.renderFaq()}
                </div>
            </div>
        );
    }
}
FaqCard.propTypes = {
    localization: Localization.propTypes.isRequired,
    height: PropTypes.number.isRequired,
    faq: PropTypes.array.isRequired,
};
